<script>
    import Toast from "./Toast.svelte";
    import { toasts } from "../util";
</script>

<div class="toaster">
    {#each $toasts as toast}
        <Toast content={toast.content} />
    {/each}
</div>

<style>
    .toaster {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
</style>
